<div class="container">
  <app-row align="center" justify="center" class="pt-8">
    <app-col sm="9" md="8" lg="7" class="pt-sm-8 mt-md-8 text-center text-primary">
        <h1 class="text-primary pt-lg-8 mt-xl-8" style="text-shadow: 2px 4px 2px rgba(0, 0, 0, .2); font-size: 48px; line-height: 1;">Sorry 😢!</h1>
        <h1 class="text-primary mt-4" style="opacity: .5; letter-spacing: 2px; font-size: 114px; text-shadow: 4px 8px 4px rgba(0, 0, 0, .2); line-height: 1">404</h1>
        <h3 class="text-primary mt-0" style="text-shadow: 2px 4px 2px rgba(0, 0, 0, .2);">Page Not Found</h3>
    </app-col>
  </app-row>
</div>
